export default __webpack_public_path__ + "static/media/Policies.3670a444.svg";